export default
    {
        "data": {
            "status": "success",
            "response": {
                "data": [
                    {
                        "Modified Date": 1679229041375,
                        "Created Date": 1666514492412,
                        "Created By": "admin_user_blisspot1_test",
                        "banner_image": "https://import.cdn.thinkific.com/269860/kVHh4nSqTxmZvWJR4SRc_Majesty%20Mindset%20Finalpng.png",
                        "banner_tile_image": "https://import.cdn.thinkific.com/269860/kVHh4nSqTxmZvWJR4SRc_Majesty%20Mindset%20Finalpng.png",
                        "title_text": "MAJESTY Mindset",
                        "uid_text": "816745",
                        "product_id_text": "858262",
                        "description_text": "A 360° Self Improvement Program to Incorporate Mindfulness, Abundance, Joyfulness, Equanimity, Strength, Thankfulness and Youthfulness into your Life.",
                        "keywords_list_text": [
                            "david",
                            "alan",
                            "david alan",
                            "majesty mindset",
                            "mindset",
                            "self improvement",
                            "360° self-improvement program",
                            "mindfulness",
                            "abundance",
                            "joyfulness",
                            "equanimity",
                            "strength",
                            "thankfulness",
                            "youthfulness",
                            "self-control",
                            "emotions",
                            "lifelong happiness",
                            "express gratitude",
                            "youthful spirit",
                            "positive outlook",
                            "powerful mindset",
                            "strong mindset",
                            "growth mindset",
                            "self care",
                            "emotions",
                            "relationships",
                            "stress",
                            "step-by-step",
                            "guide",
                            "guided",
                            "blisspot",
                            "self-care",
                            "confidence",
                            "empowerment",
                            "personal",
                            "growth",
                            "self-improvement",
                            "program",
                            "thoughts",
                            "positive",
                            "negative",
                            "thinking",
                            "online",
                            "course",
                            "digital"
                        ],
                        "user_id_text": "18285747",
                        "instructor_id_text": "372328",
                        "chapter_ids_list_text": [
                            "3795872",
                            "3654150",
                            "3654151",
                            "3654152",
                            "3654264",
                            "3654265",
                            "3654266",
                            "3654269"
                        ],
                        "productable_type_text": "Course",
                        "product_price_number": 0,
                        "product_position_number": 28,
                        "product_status_text": "published",
                        "product_name_text": "MAJESTY Mindset",
                        "product_subscription_boolean": false,
                        "product_has_certificate_boolean": false,
                        "product_seo_title_text": "MAJESTY Mindset Course - Self Improvement | Blisspot",
                        "product_seo_description_text": "Negative thought habits can be a setback to your growth. These affirmations and guided meditations will help improve your mindset. Achieve greater fulfillment now.",
                        "product_slug_text": "majesty-mindset",
                        "instructor_names1_text": "David  Alan",
                        "authors1_list_custom_authors": [
                            "1666510013767x988068042119576800"
                        ],
                        "playlists_list_custom_category": [
                            "1673172171962x173335139306753700",
                            "1673172171963x543158200050478850",
                            "1673172171963x603968575453458000",
                            "1673172171963x889940851489685100",
                            "1673172171964x935630265321384300",
                            "1673172171964x937526320748589600",
                            "1673172172128x327293003923009540",
                            "1673172172128x899178106542590100"
                        ],
                        "tags_list_text": [
                            "genesis"
                        ],
                        "search_blob_text": "<p><em><strong>hi, i&#39;m david alan.</strong></em></p>\n\n<p>&nbsp;</p>\n\n<p>my passion is helping people develop a success mindset that positively impacts all areas of their personal and professional lives.</p>\n\n<p>&nbsp;</p>\n\n<p>my focus is on character development and promoting classic virtues such as self-reliance, perseverance, courage, positivity, kindness, self-confidence, and emotional mastery.</p>\n\n<p>&nbsp;</p>\n\n<p>i am the producer of the <em>inspirational living podcast</em>, which has been downloaded over 17 million times and is among the most popular self-development podcasts worldwide.</p>\n\n<p><br />\n<strong>the following resources are available on blisspot:</strong><br />\n&nbsp;</p>\n\n<ul>\n        <li><strong><em>the majesty mindset </em>course</strong></li>\n        <li><strong><em>success mindset podcast </em>series</strong></li>\n        <li><strong><em>majesty meditation: </em>with&nbsp;the&nbsp;revolutionary autosuggestion sound method&trade; designed to unlock the power of your mind</strong></li>\n</ul>\n\n<p>&nbsp;</p>\n\n<p>learn how to achieve your goals and live your best life.</p>\n\n<p>&nbsp;</p>\n\n<p>&nbsp;</p>\ndavidalanpodcastersuccess mindsetgenesisgenesisa 360° self improvement program to incorporate mindfulness, abundance, joyfulness, equanimity, strength, thankfulness and youthfulness into your life.david , alan , david alan , majesty mindset , mindset , self improvement , 360° self-improvement program , mindfulness , abundance , joyfulness , equanimity , strength , thankfulness , youthfulness , self-control , emotions , lifelong happiness , express gratitude , youthful spirit , positive outlook , powerful mindset , strong mindset , growth mindset , self care , emotions , relationships , stress , step-by-step , guide , guided , blisspot , self-care , confidence , empowerment , personal , growth , self-improvement , program , thoughts , positive , negative , thinking , online , course , digitalmajesty mindsetnegative thought habits can be a setback to your growth. these affirmations and guided meditations will help improve your mindset. achieve greater fulfillment now.majesty mindset course - self improvement | blisspotmajesty mindset",
                        "_id": "1666514492412x468138117006153340"
                    },
                    {
                        "Modified Date": 1679229041854,
                        "Created Date": 1666514492608,
                        "Created By": "admin_user_blisspot1_test",
                        "banner_image": "https://import.cdn.thinkific.com/269860/ohDojqnwTcWsbZY478ND_life%20improvement.jpg",
                        "banner_tile_image": "https://import.cdn.thinkific.com/269860/ohDojqnwTcWsbZY478ND_life%20improvement.jpg",
                        "title_text": "Men's Health Course",
                        "uid_text": "976855",
                        "product_id_text": "1026386",
                        "description_text": "7 Ways to Improving Your Health and Wellbeing",
                        "keywords_list_text": [
                            "health",
                            "adrian",
                            "hanks",
                            "men",
                            "male",
                            "course",
                            "reflection",
                            "wellbeing",
                            "lifestyle",
                            "mindset",
                            "step-by-step",
                            "guide",
                            "guided",
                            "blisspot",
                            "self-care",
                            "confidence",
                            "empowerment",
                            "personal",
                            "growth",
                            "self-improvement",
                            "online",
                            "mens",
                            "course",
                            "body",
                            "emotions",
                            "stress"
                        ],
                        "user_id_text": "18285747",
                        "instructor_id_text": "436208",
                        "chapter_ids_list_text": [
                            "4378991",
                            "4384187",
                            "4420800",
                            "4428687",
                            "4429702",
                            "4429705",
                            "4429707"
                        ],
                        "productable_type_text": "Course",
                        "product_price_number": 0,
                        "product_position_number": 45,
                        "product_status_text": "published",
                        "product_name_text": "Men's Health Course",
                        "product_subscription_boolean": false,
                        "product_has_certificate_boolean": false,
                        "product_seo_title_text": "Men's Health Course - Improve Your Wellbeing | Blisspot",
                        "product_seo_description_text": "Taking care of yourself requires hard work and self-reflection. This course will guide you in improving your mindset and lifestyle. Enhance your health and wellbeing now.",
                        "product_slug_text": "men-s-health-course",
                        "instructor_names1_text": "Adrian Hanks",
                        "authors1_list_custom_authors": [
                            "1666510013769x545557509742988800"
                        ],
                        "playlists_list_custom_category": [
                            "1666516557648x944149178481603800",
                            "1666516557648x745356166804985100",
                            "1666516557648x837999028927958200",
                            "1666516557647x123444887897720560",
                            "1666516557647x514696287030909500",
                            "1666516557647x353177878114374400",
                            "1666516557647x741199705012227800"
                        ],
                        "tags_list_text": [
                            "genesis"
                        ],
                        "search_blob_text": "<p><em><strong>hi, i&#39;m adrian hanks</strong></em></p>\n\n<p>&nbsp;</p>\n\n<p>i am a&nbsp;holistic health and wellbeing&nbsp;expert,&nbsp;inspirational author, coach, counsellor, psychotherapist and speaker.&nbsp;i love to support people in looking after, and investing in, their&nbsp;greatest asset&mdash;their health and wellbeing.</p>\n\n<p>&nbsp;</p>\n\n<p>i have over 20 years of experience working&nbsp;as a <em>psychophonetics</em>&nbsp;holistic counsellor and a psychotherapist&nbsp;(advanced diploma), leading edge master-coach, facilitator, and trainer&nbsp;(certificate 4 workplace training &amp; assessment, 2000).</p>\n\n<p>&nbsp;</p>\n\n<p>i am the director of <em>the blue wren foundation</em>&nbsp;(his charity organisation) and co-director of <em>the corporate alchemist project</em>&nbsp;(health, wellbeing and peak performance guidance for business leaders and executives).&nbsp;</p>\n\n<p>&nbsp;</p>\n\n<p>i love to focus on helping people bring more focus, presence, passion, purpose, and joy&nbsp;into their lives, so they can live life to the full in a more authentic and conscious way.</p>\n\n<p>&nbsp;</p>\n\n<p>this is my focus and passion, and this comes across in the way in which i write, connect, and work with people and in the way in which i live my own life&mdash;authentically and consciously&nbsp;(as much as i can!)&nbsp;​</p>\n\n<p>&nbsp;</p>\n\n<p>i measure life with 10 key life aspects.&nbsp;these life aspects include the&nbsp;physical, emotional, mental, spiritual, financial, creative, social, vocational, sexual, and intimate. these are further explained in his books: <em>where am &#39;i&#39; right now?</em>&nbsp;and my <em>10 life aspects journal.</em></p>\n\n<p>&nbsp;</p>\n\n<p>join me in my mission to create a world filled with more purposeful, conscious, and fulfilled individuals.<br />\n&nbsp;</p>\n\n<p>my <em>men&#39;s health course</em>,</p>\n\n<p>&nbsp;</p>\n\n<p><strong>enroll in my</strong><em><strong> men&#39;s health course&nbsp;</strong></em><strong>available on blisspot, which is designed to help men lead a more focused, meaningful, and healthy life.</strong><em><strong><strong> </strong></strong></em><br />\n<br />\nstart your journey towards a happier and more fulfilling life.&nbsp;it&#39;s never too late to invest in your health and well-being.</p>\nadrianhanksadvdip counselling and psychotherapy, cert iv workplace training and assessment, cert iv anthroposophical studies (spiritual/educational studies, rudolf steiner), certified group and individual coach, international mc/professional speakerlife alchemistgenesisgenesis7 ways to improving your health and wellbeinghealth , adrian , hanks , men , male , course , reflection , wellbeing , lifestyle , mindset , step-by-step , guide , guided , blisspot , self-care , confidence , empowerment , personal , growth , self-improvement , online , mens , course , body , emotions , stressmen's health coursetaking care of yourself requires hard work and self-reflection. this course will guide you in improving your mindset and lifestyle. enhance your health and wellbeing now.men's health course - improve your wellbeing | blisspotmen's health course",
                        "_id": "1666514492608x734806251524998000"
                    },
                    {
                        "Modified Date": 1679229049504,
                        "Created Date": 1666514492837,
                        "Created By": "admin_user_blisspot1_test",
                        "banner_image": "https://import.cdn.thinkific.com/269860/courses/1732055/pdjYL7pdQV2iIzvI2DxA_Barry%20-%20Stress.png",
                        "banner_tile_image": "https://import.cdn.thinkific.com/269860/courses/1732055/pdjYL7pdQV2iIzvI2DxA_Barry%20-%20Stress.png",
                        "title_text": "How to Manage Stress and Get More from Life",
                        "uid_text": "1732055",
                        "product_id_text": "1815004",
                        "description_text": "Control the stress before it controls you",
                        "keywords_list_text": [
                            "barry",
                            "winbolt",
                            "barry winbolt",
                            "blisspot",
                            "stress",
                            "life",
                            "productivity",
                            "control",
                            "manage",
                            "relationships",
                            "harm",
                            "demand",
                            "excess",
                            "cope",
                            "natural",
                            "step-by-step",
                            "guide",
                            "guided",
                            "self-care",
                            "personal",
                            "growth",
                            "self-improvement",
                            "online",
                            "digital",
                            "course",
                            "overcome",
                            "challenges",
                            "stressful",
                            "move",
                            "forward",
                            "flow",
                            "empowered",
                            "empowerment",
                            "confindent"
                        ],
                        "instructor_id_text": "321348",
                        "chapter_ids_list_text": [
                            "7777384",
                            "7777569",
                            "7777626"
                        ],
                        "productable_type_text": "Course",
                        "product_price_number": 0,
                        "product_position_number": 29,
                        "product_status_text": "published",
                        "product_name_text": "How to Manage Stress and Get More from Life",
                        "product_subscription_boolean": false,
                        "product_has_certificate_boolean": false,
                        "product_seo_title_text": "How to Manage Stress and Get More from Life by Barry Winbolt",
                        "product_seo_description_text": "Control the stress before it controls you.\n\nLife is a constant balancing act between daily pressures and our ability to cope with them. A certain amount of stress is natural and acceptable, but it becomes harmful and counter-productive when life’s demands are excessive or constant, and beyond our ability to cope. ",
                        "product_slug_text": "How-to-Manage-Stress-and-Get-More-from-Life",
                        "instructor_names1_text": "Barry Winbolt",
                        "authors1_list_custom_authors": [
                            "1666510013753x872077011083833000"
                        ],
                        "playlists_list_custom_category": [
                            "1666516561747x571201687058167740",
                            "1666516561746x419047376526420200",
                            "1666516561746x952490241856595500"
                        ],
                        "tags_list_text": [
                            "genesis"
                        ],
                        "search_blob_text": "<p><strong>hi, i&#39;m barry winbolt</strong><br />\n&nbsp;</p>\n\n<p>i&rsquo;m a solution-focused therapist offering brief and often single-session therapy face-to-face and online. i work collaboratively with individuals and couples.<br />\n&nbsp;</p>\n\n<p>my practice is based in east sussex in the uk, and i also work with clients around the world via skype/zoom sessions. in the role of personal consultant, i work as a coach to help you in identifying what&rsquo;s important to you and how to go about getting what you want from life.<br />\n&nbsp;</p>\n\n<p>after 30 years, of delivering training and seminars in the uk and overseas, i now put my accumulated knowledge and experience into my online courses and webinars. these are all aimed at helping you <em>get a better handle on life.</em><br />\n&nbsp;</p>\n\n<p>i also do voluntary work by offering community workshops and staff training for local charities and groups in south east england.<br />\n&nbsp;</p>\n\n<p>i provide personal consulting, solution focused therapy and coaching. plus resources to help with relationships, communication skills, and personal development. prompts to help you get a better handle on life.<br />\n&nbsp;</p>\n\n<p>however resourceful, successful, fit, fulfilled and well&hellip; just ok you are, you have surely known times when your normal talent for getting it right abandoned you. my strapline&nbsp;<em>life doesn&rsquo;t have to be like that</em>&nbsp;is a reminder that there is always a way to help ourselves.<br />\n&nbsp;</p>\n\n<p>but there&rsquo;s always something you do if you have the right information and the right guidance. so i provide resources to help you get a better handle on yourself, your relationships, and life in general.<br />\n&nbsp;</p>\n\n<p>the content i create is designed to be practical, to provide or signpost things you can actually do to make a difference in your life.<br />\n&nbsp;</p>\n\n<p>i am a psychologist, therapist and trainer. i have built my career around sharing information that helps people sort out the things that trouble them.</p>\n\n<p>&nbsp;</p>\n\n<p><strong>discover the power of personal resilience, listening skills, and better sleep with barry&#39;s online courses on blisspot:</strong><br />\n&nbsp;</p>\n\n<ul>\n\t<li><strong><em>personal resilience</em></strong></li>\n\t<li><strong><em>how to become a great listener</em></strong></li>\n\t<li><strong><em>the sleep well plan</em> </strong></li>\n</ul>\n\n<p><br />\n<strong>you can also&nbsp;achieve greater happiness and success&nbsp;in life&nbsp;by booking&nbsp;<em>a one-on-one coaching session </em>with barry, on blisspot by clicking the button above.</strong></p>\n\n<p>&nbsp;</p>\n\n<p>barry can help you get a better handle on yourself, your relationship, and life in general.<br />\n<br />\n&nbsp;</p>\n\n<p>&nbsp;</p>\nbarrywinboltpsychologist, coach and therapistresilience and conflict managementgenesisgenesiscontrol the stress before it controls youbarry , winbolt , barry winbolt , blisspot , stress , life , productivity , control , manage , relationships , harm , demand , excess , cope , natural , step-by-step , guide , guided , self-care , personal , growth , self-improvement , online , digital , course , overcome , challenges , stressful , move , forward , flow , empowered , empowerment , confindenthow to manage stress and get more from lifecontrol the stress before it controls you.\n\nlife is a constant balancing act between daily pressures and our ability to cope with them. a certain amount of stress is natural and acceptable, but it becomes harmful and counter-productive when life’s demands are excessive or constant, and beyond our ability to cope. how to manage stress and get more from life by barry winbolthow to manage stress and get more from life",
                        "_id": "1666514492837x654143140163100800"
                    },
                    {
                        "Modified Date": 1679229041755,
                        "Created Date": 1666514492606,
                        "Created By": "admin_user_blisspot1_test",
                        "banner_image": "https://import.cdn.thinkific.com/269860/courses/890016/uPNBn9crRvqxAJ4Ec0dM_1.the%20secret%20of%20confident%20women.jpg",
                        "banner_tile_image": "https://import.cdn.thinkific.com/269860/courses/890016/uPNBn9crRvqxAJ4Ec0dM_1.the%20secret%20of%20confident%20women.jpg",
                        "title_text": "Secrets of Confident Women Podcast",
                        "uid_text": "890016",
                        "product_id_text": "935206",
                        "description_text": "Have the Confidence to Stand Tall and Achieve",
                        "keywords_list_text": [
                            "confident",
                            "confidence",
                            "women",
                            "jodie",
                            "bruce",
                            "clarke",
                            "anastasia",
                            "adams",
                            "secrets",
                            "woman",
                            "women",
                            "podcast",
                            "secret",
                            "series",
                            "assurance",
                            "technique",
                            "stratergy",
                            "step-by-step",
                            "guide",
                            "guided",
                            "blisspot",
                            "self-care",
                            "confidence",
                            "empowerment",
                            "personal",
                            "growth",
                            "self-improvement",
                            "online",
                            "workplace"
                        ],
                        "user_id_text": "18285747",
                        "instructor_id_text": "405923",
                        "chapter_ids_list_text": [
                            "3986661",
                            "5219158",
                            "5219203",
                            "5219209",
                            "5219211",
                            "5219212",
                            "5219216",
                            "5219217",
                            "5219218",
                            "5219219",
                            "5732059",
                            "5732513",
                            "5732633",
                            "5732716",
                            "5732761",
                            "5732813",
                            "5732815",
                            "5732816",
                            "5732817",
                            "5732818",
                            "5732820",
                            "7806011",
                            "7822553",
                            "7822564",
                            "7822620",
                            "7822707",
                            "7822742",
                            "7822801",
                            "7822879",
                            "7823009",
                            "7823130",
                            "7823141",
                            "7823169",
                            "7823207",
                            "7823288",
                            "7823374",
                            "7823389",
                            "7823490",
                            "7847427",
                            "7847462",
                            "7847562",
                            "7847588",
                            "7847668",
                            "7847726",
                            "7847799",
                            "7847868",
                            "9112639",
                            "9112651",
                            "9112670",
                            "9112706",
                            "9112742",
                            "9118201",
                            "9130316",
                            "9130356",
                            "9130513",
                            "9130546",
                            "9130595",
                            "9130745",
                            "9130786",
                            "9130978",
                            "9260901",
                            "9260989"
                        ],
                        "productable_type_text": "Course",
                        "product_price_number": 0,
                        "product_position_number": 6,
                        "product_status_text": "published",
                        "product_name_text": "Secrets of Confident Women Podcast",
                        "product_subscription_boolean": false,
                        "product_has_certificate_boolean": false,
                        "product_seo_title_text": "Secrets of Confident Women Podcast - RiSe Women | Blisspot",
                        "product_seo_description_text": "A lack of confidence can limit your progress and success. Learn how to build your self-confidence and assurance up using practical techniques. Master your confidence now.",
                        "product_slug_text": "secrets-of-confident-women-podcast",
                        "instructor_names1_text": "Jodie Bruce-Clarke and Anastasia Adams",
                        "authors1_list_custom_authors": [
                            "1666510013768x284705846654151880"
                        ],
                        "playlists_list_custom_category": [
                            "1666516558765x419229889464789250",
                            "1666516558958x273359949241095200",
                            "1666516558958x979355672871115500",
                            "1666516558957x790261548899337000",
                            "1666516558957x898080464865689700",
                            "1666516558957x461941674961351400",
                            "1666516558957x419105454423396300",
                            "1666516558957x735427114202838400",
                            "1666516558956x535766161603419500",
                            "1666516558956x950818324183403100",
                            "1666516559932x666234246508830000",
                            "1666516559930x457628587843957600",
                            "1666516559927x988204927308957800",
                            "1666516559925x583008759730880900",
                            "1666516559925x750089957510062700",
                            "1666516559924x172117951476428380",
                            "1666516559924x191042687827237100",
                            "1666516559924x104331827495680140",
                            "1666516559818x541850692082231700",
                            "1666516559818x836533724106175600",
                            "1666516559817x314309744218379800",
                            "1666516561740x895910622953116800",
                            "1666516561740x180209009740558880",
                            "1666516561740x811100322195413600",
                            "1666516561740x359954765426818050",
                            "1666516561734x259525688637640030",
                            "1666516561734x705762659844383700",
                            "1666516561734x696430988318243600",
                            "1666516561734x302847626436488300",
                            "1666516561734x439720626689783300",
                            "1666516561734x606708275036886800",
                            "1666516561733x716090918387496400",
                            "1666516561733x811520015830570600",
                            "1666516561733x474026542860604740",
                            "1666516561733x980027937019168300",
                            "1666516561730x848057982147593100",
                            "1666516561730x569190657431173360",
                            "1666516561730x182613330966582940",
                            "1666516561730x604927072038526500",
                            "1666516561730x714596596238996600",
                            "1666516561729x609260921425177200",
                            "1666516561729x606370581756382700",
                            "1666516561729x425351065524448560",
                            "1666516561729x551451985013165200",
                            "1666516561729x820339401381031400",
                            "1666516561621x432538585313245760",
                            "1666516561359x472173591361857400",
                            "1666516561217x567693461236968200",
                            "1666516561217x228070003343570080",
                            "1666516561217x258355492555286660",
                            "1666516561216x634868338979602800",
                            "1666516561216x743311045400503200",
                            "1666516561215x667507046564441700",
                            "1666516561215x302216118301752200",
                            "1666516561214x581151779364143900",
                            "1666516561214x334704886624600060",
                            "1666516561214x712308791534445000",
                            "1666516561213x878085994416815600",
                            "1666516561213x565029829540126400",
                            "1666516561213x261289190384994100",
                            "1666516561165x859343691008787000",
                            "1666516561164x980095617123085000"
                        ],
                        "tags_list_text": [
                            "genesis"
                        ],
                        "search_blob_text": "<p><em><strong>hi, i&#39;m jodie bruce-clarke</strong></em></p>\n\n<p>&nbsp;</p>\n\n<p>i am the founder (and one-half) of rise women and a&nbsp;confident woman!</p>\n\n<p>&nbsp;</p>\n\n<p><em>are you a confident woman all the time? </em>you may ask. well, the truth is, i&#39;m not! but that&#39;s why i&#39;m here, and it&#39;s also the reason why rise women was created.</p>\n\n<p>&nbsp;</p>\n\n<p>let me tell you, i was not born with truckloads of confidence, nor did i have some magical gift or superhuman genetic code. my confidence is the result of years of growth, learning, mistakes, and practice. it&#39;s something i work on daily, using practical techniques that now, through rise women, i can share with you.</p>\n\n<p>&nbsp;</p>\n\n<p>over the years, i&#39;ve had the opportunity to teach many clients and audiences the confidence techniques that i use to help them design their own personalized confidence programs to use for life.</p>\n\n<p>&nbsp;</p>\n\n<p>i&#39;m an unapologetically-honest, red-obsessed, bold and bright, tell-it-like-it-is sort of woman. i am outspoken on topics i truly believe in, especially the rights of women and children to live in safe, loving, and healthy environments.</p>\n\n<p>&nbsp;</p>\n\n<p>rise women is my passion, and i&#39;d love to get to know you and help you build the confidence levels you&#39;ve always wanted.</p>\n\n<p>&nbsp;</p>\n\n<p>&nbsp;</p>\n\n<p><em><strong>hi, i&#39;m anastasia adams</strong></em></p>\n\n<p>&nbsp;</p>\n\n<p>i&#39;m the other half of rise women, and like jodie, i&#39;m a confident woman too!</p>\n\n<p>&nbsp;</p>\n\n<p>jodie and i are amazing friends and partners-in-crime. we laugh and learn together all the time, and we&#39;re on a mission to support women all around the world. we provide practical confidence techniques to help women be the best version of themselves and live the life they really want. we offer our book, <em>pumped,</em> our keynotes and workshops, and our online course <em>confidence for women in the workplace</em> to achieve our mission.</p>\n\n<p>&nbsp;</p>\n\n<p>through rise women, jodie and i have connected with so many amazing women and have taught them the confidence techniques they need to know to live their best life possible.</p>\n\n<p>&nbsp;</p>\n\n<p>and i can tell you this works because i&#39;ve lived it firsthand. my life&#39;s road has been bumpy at times, as it often is for all of us. but with the techniques i&#39;ve learned (and apply daily), i&#39;ve been able to boost my confidence and change my life.</p>\n\n<p>&nbsp;</p>\n\n<p>aside from rise women, i work for the neuroleadership institute, an inspiring and innovative organization that combines leadership programs with neuroscience. i love the flexibility and continual growth that i get from this role, and i&#39;m fortunate to work with an amazing group of like-minded people.</p>\n\n<p>&nbsp;</p>\n\n<p>i&#39;m a super-positive and high-energy, self-confessed spelling and grammar policewoman, with a legal background and the desire to do something &#39;more&#39; in life.</p>\n\n<p>&nbsp;</p>\n\n<p><strong>available on blisspot is our highly popular resources:</strong></p>\n\n<p>&nbsp;</p>\n\n<ul>\n\t<li>\n\t<p><em><strong>confidence for women in the workplace </strong></em><strong>online course</strong></p>\n\t</li>\n\t<li>\n\t<p><em><strong>secrets of confident women </strong></em><strong>podcast</strong></p>\n\t</li>\n</ul>\n\n<p>&nbsp;</p>\n\n<p>whether you want to boost your confidence in the workplace or in life, our empowering insights and practical strategies can help you unleash your inner strength and achieve your goals.</p>\n\n<p>&nbsp;</p>\n\n<p>don&#39;t miss this opportunity to take your confidence to the next level and create a life you love!</p>\n\n<p>&nbsp;</p>\njodie bruce-clarkeand anastasia adamsjodie bruce-clarke: advanced habit change practitioner, certified coach, ba commerce (marketing/management); anastasia adams: certified coach, ba arts and law\nwomen's confidencehave the confidence to stand tall and achieveconfident , confidence , women , jodie , bruce , clarke , anastasia , adams , secrets , woman , women , podcast , secret , series , assurance , technique , stratergy , step-by-step , guide , guided , blisspot , self-care , confidence , empowerment , personal , growth , self-improvement , online , workplacesecrets of confident women podcasta lack of confidence can limit your progress and success. learn how to build your self-confidence and assurance up using practical techniques. master your confidence now.secrets of confident women podcast - rise women | blisspotsecrets of confident women podcast",
                        "_id": "1666514492606x837667810721993700"
                    },
                    {
                        "Modified Date": 1679229041619,
                        "Created Date": 1666514492605,
                        "Created By": "admin_user_blisspot1_test",
                        "banner_image": "https://import.cdn.thinkific.com/269860/SnbrMtkmS3SO006g7AWd_the%20self%20work%20podcast-54.jpg",
                        "banner_tile_image": "https://import.cdn.thinkific.com/269860/SnbrMtkmS3SO006g7AWd_the%20self%20work%20podcast-54.jpg",
                        "title_text": "The SelfWork Podcast",
                        "uid_text": "855684",
                        "product_id_text": "899155",
                        "description_text": "Overcome Your Personal Emotional and Relationship Struggles",
                        "keywords_list_text": [
                            "motivation",
                            "self-care",
                            "podcast",
                            "self",
                            "work",
                            "positive",
                            "change",
                            "anxiety",
                            "perfectionism",
                            "dr",
                            "margaret",
                            "rutherford",
                            "argument",
                            "anger",
                            "relationships",
                            "meaning",
                            "relation",
                            "discover",
                            "conflict",
                            "fight",
                            "depression",
                            "anxiety",
                            "stratergy",
                            "excercise",
                            "struggle",
                            "step-by-step",
                            "guide",
                            "guided",
                            "blisspot",
                            "self-care",
                            "confidence",
                            "empowerment",
                            "personal",
                            "growth",
                            "self-improvement",
                            "online"
                        ],
                        "user_id_text": "18285747",
                        "instructor_id_text": "391446",
                        "chapter_ids_list_text": [
                            "3986489",
                            "3824920",
                            "5611837",
                            "3944078",
                            "3944045",
                            "3944055",
                            "3944047",
                            "5611902",
                            "5611914",
                            "3944076",
                            "5611972",
                            "5611950",
                            "5731985",
                            "5732017",
                            "5732070",
                            "5732225",
                            "5732473",
                            "5732519",
                            "5732556",
                            "5732587",
                            "5732623",
                            "5732634"
                        ],
                        "productable_type_text": "Course",
                        "product_price_number": 0,
                        "product_position_number": 48,
                        "product_status_text": "published",
                        "product_name_text": "The SelfWork Podcast",
                        "product_subscription_boolean": false,
                        "product_has_certificate_boolean": false,
                        "product_seo_title_text": "The SelfWork Podcast - Heal Your Struggles | Blisspot",
                        "product_seo_description_text": "Depression and anxiety are challenging to manage and their traits are not always obvious.  These strategies and exercises can help you identify and mitigate their effects. Overcome your struggles now.",
                        "product_slug_text": "selfwork-podcasts",
                        "instructor_names1_text": "Dr. Margaret Rutherford",
                        "authors1_list_custom_authors": [
                            "1666510013768x608753734099453000"
                        ],
                        "playlists_list_custom_category": [
                            "1666516558808x853901542780535200",
                            "1666516560147x584516603607280300",
                            "1666516560147x712678077123200000",
                            "1666516560146x546566412454668740",
                            "1666516560146x827394339380523000",
                            "1666516560146x224387306496992580",
                            "1666516559933x746327975009596200",
                            "1666516559932x780791546400895600",
                            "1666516559932x355646239025742460",
                            "1666516559932x123418179537162500",
                            "1666516559932x141661992725141680",
                            "1666516559930x911242794499115500",
                            "1666516559928x355765742324742900",
                            "1666516559927x639669416974410000",
                            "1666516559927x279681875511128770",
                            "1666516559927x752323916828500500",
                            "1673172171953x249279071524331600",
                            "1673172172140x220390301989154200",
                            "1673172172140x496689872448942140",
                            "1673172172141x530366579184089300",
                            "1673172172141x675280919101116700",
                            "1673172172141x805951653616763200"
                        ],
                        "tags_list_text": [
                            "genesis"
                        ],
                        "search_blob_text": "<p><strong><em>hello, i&#39;m dr margaret rutherford</em></strong></p>\n\n<p>&nbsp;</p>\n\n<p>i&rsquo;m so glad you&rsquo;re here. as a psychologist in private practice for almost 30 years, i love helping people and improving their mental health. i&#39;m also dedicated to informing the public about what therapy has to offer and making mental health treatment more approachable. that&#39;s why i blog and host <em>the selfwork podcast.</em></p>\n\n<p>&nbsp;</p>\n\n<p><em>the selfwork podcast</em>&nbsp;has been ranked a top podcast on depression and mental health and has earned more than 4 million downloads. i&rsquo;ve created monthly facebook lives for <em>the mighty </em>and most recently, have begun another interactive podcast on&nbsp;the <em>fireside app<a href=\"https://firesidechat.com/margaretrutherford\">,</a>&nbsp;selfwork chat.</em> and my book, entitled<em>&nbsp;perfectly hidden depression: how to break free from the perfectionism that masks your depression,</em>&nbsp;was launched in november 2019.</p>\n\n<p>&nbsp;</p>\n\n<p><em>perfectly hidden depression</em>, focuses on how destructive perfectionism can act as an unconscious camouflage for silent despair, loneliness, and even suicidal thoughts. i&#39;ve been researching and writing on this topic for five years, and i&#39;m passionate about the message that although depression can be heavily masked by perfectionism, its damage can still be devastating to someone who&#39;s trying so hard to smile their way through growing loneliness and despair. along the way, i&#39;ve met many authors, researchers, bloggers, and psychologists.</p>\n\n<p>&nbsp;</p>\n\n<p>i&rsquo;ve written for <em>huffpost, psychology today, the mighty, psych central, the gottman blog, psychologies, stigmafighters, the good men project, this is my brave,</em> and others as i&rsquo;ve spread what i hope is a passionate message about becoming more comfortable with vulnerability in everyday life, and confronting the prejudice against not only mental illness itself but its treatment.</p>\n\n<p>&nbsp;</p>\n\n<p><strong>if you&#39;re interested in my podcast, </strong><em><strong>the selfwork podcast, </strong></em><strong>you can find it on blisspot.</strong></p>\n\n<p>&nbsp;</p>\n\n<p>give it a listen and join me on the journey to better mental health and self-discovery.</p>\ndr. margaretrutherfordphd clinical psychology, dr philosophyovercoming destructive perfectionism overcome your personal emotional and relationship strugglesmotivation , self-care , podcast , self , work , positive , change , anxiety , perfectionism , dr , margaret , rutherford , argument , anger , relationships , meaning , relation , discover , conflict , fight , depression , anxiety , stratergy , excercise , struggle , step-by-step , guide , guided , blisspot , self-care , confidence , empowerment , personal , growth , self-improvement , onlinethe selfwork podcastdepression and anxiety are challenging to manage and their traits are not always obvious.  these strategies and exercises can help you identify and mitigate their effects. overcome your struggles now.the selfwork podcast - heal your struggles | blisspotthe selfwork podcast",
                        "_id": "1666514492605x516330012561805100"
                    },
                    {
                        "Modified Date": 1679229033400,
                        "Created Date": 1666514491436,
                        "Created By": "admin_user_blisspot1_test",
                        "banner_image": "https://import.cdn.thinkific.com/269860/cRMFFnOrRbHf6xF0wEmu_10daysleep.jpg",
                        "banner_tile_image": "https://import.cdn.thinkific.com/269860/cRMFFnOrRbHf6xF0wEmu_10daysleep.jpg",
                        "title_text": "The 10 Day Sleep Challenge",
                        "uid_text": "699987",
                        "product_id_text": "736244",
                        "description_text": "Sleep Better to Live Better",
                        "keywords_list_text": [
                            "10",
                            "day",
                            "sleep",
                            "challenge",
                            "improve",
                            "blisspot",
                            "10 day sleep challenge",
                            "improve",
                            "sleep",
                            "insomnia",
                            "problems",
                            "negatively",
                            "impact",
                            "affect",
                            "health",
                            "desperate",
                            "stress",
                            "habits",
                            "daytime",
                            "energy",
                            "improve",
                            "sleep routine",
                            "beatrix",
                            "schmidt",
                            "online",
                            "course",
                            "restless",
                            "restful",
                            "sound",
                            "peaceful",
                            "peace",
                            "self-care",
                            "blisspot",
                            "step-by-step",
                            "guide",
                            "guided",
                            "digital",
                            "course",
                            "personal",
                            "development",
                            "self-investment",
                            "journey",
                            "growth",
                            "grow",
                            "person"
                        ],
                        "user_id_text": "18285747",
                        "instructor_id_text": "321349",
                        "chapter_ids_list_text": [
                            "3146365",
                            "3146368",
                            "3146372",
                            "3146376",
                            "3146378",
                            "3146380",
                            "3146384",
                            "3146385",
                            "3146386",
                            "3146387",
                            "3146389",
                            "3154110"
                        ],
                        "productable_type_text": "Course",
                        "product_price_number": 39,
                        "product_position_number": 14,
                        "product_status_text": "published",
                        "product_name_text": "The 10 Day Sleep Challenge",
                        "product_subscription_boolean": false,
                        "product_has_certificate_boolean": false,
                        "product_seo_title_text": "The 10 Day Sleep Challenge - Improve Your Sleep | Blisspot",
                        "product_seo_description_text": "Sleep problems can negatively affect your overall health. Take The 10 Day Sleep Challenge to improve your sleep, overcome insomnia,and enhance your energy and vitality. Support yourself by sleeping well.",
                        "product_slug_text": "the-10-day-sleep-challenge",
                        "instructor_names1_text": "Beatrix A Schmidt",
                        "authors1_list_custom_authors": [
                            "1666510013754x162318440979252640"
                        ],
                        "playlists_list_custom_category": [
                            "1666516554862x958953619945054800",
                            "1666516554862x345159365220398600",
                            "1666516554862x684149167327256200",
                            "1666516554861x420831159451317250",
                            "1666516554861x911124904330770800",
                            "1666516554861x140520079851118370",
                            "1666516554861x388972872834401300",
                            "1666516554860x616591567737924100",
                            "1666516554858x398201941207098050",
                            "1666516554858x304750892017742200",
                            "1666516554858x622648386098938800",
                            "1666516554625x721512360132335600"
                        ],
                        "tags_list_text": [
                            "genesis"
                        ],
                        "search_blob_text": "<p><strong><em>hi, i&#39;m beatrix schmidt</em></strong></p>\n\n<p>&nbsp;</p>\n\n<p>i am a sleep coach, speaker, author of the online course <em>the sleep deep method</em>&reg; and founder of <em>the sleep deep practice</em>. i focus my work on raising awareness about insomnia, sleep problems caused by lifestyle choices, and how these affect our everyday lives.</p>\n\n<p>&nbsp;</p>\n\n<p>having struggled with insomnia and burning myself out in my mid-twenties, i spent the last ten years researching sleep and learning that in order for us to sleep well at night, we need to look much deeper than just how tired we are.</p>\n\n<p>&nbsp;</p>\n\n<p>with my diverse knowledge in alternative therapies, business strategy and private health care, i successfully applied the best tools and techniques of my methodology in my private practice working with a number of clients from ceos and senior executives to entrepreneurs to help them optimise their sleep, which also worked with their demanding lifestyles. from sleep hygiene to personal boundaries, and productivity, there are so many benefits to my strategic approach to sleeping and living well.</p>\n\n<p>&nbsp;</p>\n\n<p>i am a highly sought-after speaker and coach within the corporate, educational, and personal development sectors. i have been presenting workshops and talks for a number of years and have been invited to take part in panel discussions and interviews as an expert in my field.</p>\n\n<p>&nbsp;</p>\n\n<p><em><strong>looking to improve the quality of your sleep? check out my online course, the sleep deep method&reg;, available on blisspot. </strong></em><br />\n&nbsp;</p>\n\n<p>join now to learn effective techniques and practices to help you achieve deep, restful sleep every night.</p>\n\n<p>&nbsp;</p>\nbeatrix aschmidtmaster trainersleepsleep better to live better10 , day , sleep , challenge , improve , blisspot , 10 day sleep challenge , improve , sleep , insomnia , problems , negatively , impact , affect , health , desperate , stress , habits , daytime , energy , improve , sleep routine , beatrix , schmidt , online , course , restless , restful , sound , peaceful , peace , self-care , blisspot , step-by-step , guide , guided , digital , course , personal , development , self-investment , journey , growth , grow , personthe 10 day sleep challengesleep problems can negatively affect your overall health. take the 10 day sleep challenge to improve your sleep, overcome insomnia,and enhance your energy and vitality. support yourself by sleeping well.the 10 day sleep challenge - improve your sleep | blisspotthe 10 day sleep challenge",
                        "_id": "1666514491436x768313505311485200"
                    }
                ]
            }
        },
        "status": 200,
        "statusText": "OK",
        "headers": {
            "content-type": "application/json"
        },
        "config": {
            "transitional": {
                "silentJSONParsing": true,
                "forcedJSONParsing": true,
                "clarifyTimeoutError": false
            },
            "transformRequest": [
                null
            ],
            "transformResponse": [
                null
            ],
            "timeout": 0,
            "xsrfCookieName": "XSRF-TOKEN",
            "xsrfHeaderName": "X-XSRF-TOKEN",
            "maxContentLength": -1,
            "maxBodyLength": -1,
            "env": {
                "FormData": null
            },
            "headers": {
                "Accept": "application/json, text/plain, */*"
            },
            "baseURL": "https://blisspot.io/api/1.1/obj",
            "withCredentials": false,
            "credentials": false,
            "method": "get",
            "url": "https://blisspot.io/api/1.1/wf/courses-genesis"
        },
        "request": {}
    }